<div class="unauthorized-container">
    <h1>Error 401 - Unauthorized.</h1>
    <h3>You will be redirected to the <a [attr.href]="loginUrl">Login Page</a> in {{countdown}}</h3>
</div>